//布局
<template>
  <div id="modelcomp">
    <div id="waiting-texture">
      <i class="iconfont icon-waiting waiting-texture"></i>
    </div>
    <div id="model-demo"></div>
    <div id="hotpoint-div"></div>
  </div>
</template>

// 逻辑

<script>
import TWEEN from "tween.js";
import * as THREE from "three";
import {
  GodMaterial,
  Material,
  toGodMaterial,
  toPanoMaterial,
} from "./ModelMaterial_offscreen";
import {
  HotpointSet,
  TitleHotpoint,
  MusicHotpoint,
  initHotpoints,
  addHotpoint,
} from "./Hotpoint";
import { ExtraObjectSet, VerticalVedioPanel } from "./ExtraObject";
import { Scene } from "./Scene";
import { Model } from "./Model";
import { CPointSet } from "./CameraPoints";
import { EditPointSet } from "./EditPoints";
import { Camera } from "./Camera";
import { Renderer } from "./Renderer";
import { Keyboard } from "./Keyboard";
import { Cursor } from "./Cursor";
import { MobileTouch } from "./MobileTouch";
import { CameraController } from "./CameraController";
import { ViewSet } from "./View";
import {
  BuildingTagSet,
  NameBuildingTag,
  initBuildingTags,
} from "./BuildingTag";
import { EnterPointSet, EnterType } from "./EnterPoint";
import * as Utils from "./Utils";
import { HUD } from "./HUD";
import { EventEmitter } from "events/events";
import { Events } from "./Events";
import { AudioManager } from "./AudioManager";
import { HotpointPlayer } from "./HotpointPlayer";
import { VRControl } from "./VR";
import { SingleView } from "./SingleView";
import { MathUtils } from 'three'
import { Euler } from 'three';
import { GUITool } from './GUITool'

export default {
  name: "modelDemo-test",
  components: {},
  props: {},
  data() {
    return {};
  },
  beforeCreate() {},
  created() {
    //初始化关闭弹窗
    this.$hotpoint.close()
  },
  mounted() {},
  methods: {
    /**
     * 运行方法
     * @param {} settings 配置文件
     * @param {boolean} isEditPoint 是否为编辑模式
     */
    async run(settings, isEditPoint = false) {
      console.log("welgl components init start");
      this.settings = settings;
      // todo 修改为确定类型
      this.isEdit = isEditPoint;

      await this.init();
      await this.load();

      console.log("welgl components init end");
    },

    /**
     * 初始化弹窗方法
     */
    initPopWindowsUtils() {
      Utils.WindowsUtls.pop = (types, msgs) => {
        const set = new Set();
        let info = [];
        types.forEach((value, key) => {
          set.add(value);
          let data = [];
          if(typeof msgs[key] === "object" &&  msgs[key].length > 0) {
            msgs[key].forEach((val,key)=>{
              if(val !=='' && val !=="" && val !== undefined && val !==null) {
                data.push(val);
              }
            });
            info.push({
              type: value,
              content: data
            });
          }
          else {
            info.push({
              type: value,
              content: msgs[key]
            })
          }
        });
        if(set.has("text")) {
          document.querySelector(".custom-content-container").style.background = "#fff";
        }
        else {
          if (!!document.querySelector(".custom-content-container")) document.querySelector(".custom-content-container").style.background = "transparent";
        }
        this.$emit(Events.HotpointOpen, types);
        this.$hotpoint.init("800px", "600px", info);
        this.$hotpoint.instance.$once(
          Events.HotpointClose,
          (() => {
            this.$emit(Events.HotpointClose);
          }).bind(this)
        );
      };
      Utils.WindowsUtls.close = () => {
        this.$hotpoint.close();
      };
      Utils.WindowsUtls.getMediaLen = async () => {
        return Math.max(await this.$hotpoint.mediaLen());
      };
    },

    /**
     * 初始化方法
     */
    async init() {
      this.initPopWindowsUtils();
      let ua = Utils.getPlatform();

      this._scene = new Scene();
      this._material = new Material(
      this.settings.model.textureRoot,
      this.settings.pointList.length);
      this._godMaterial = new GodMaterial();
      this._model = new Model(this.settings.model.modelUrl);
      // test singleView
      this._singleView = new SingleView(this._scene, this._model);
      // test singleView
      this._cpointset = new CPointSet(
      this.settings.model,
      this.settings.pointList,
      this._scene
      );
      // test
      if (this.isEdit){
        const iconUrlSet = {
          iconTexture:this.settings.model.iconUrl,
          iconDisableTexture:require('@/assets/img/pictures/disable_512x512.png'),
          onVisiableTexture:require('@/assets/img/pictures/disable_on_256x256.png'),
          offVisiableTexture:require('@/assets/img/pictures/disable_off_256x256.png')
        }
        this._epointset = new EditPointSet(
          iconUrlSet,
          this.settings.pointList,
          this._cpointset,
          this._scene.scene,
          this.settings.model.mgraph
        );
      }
      // test
      this._camera = new Camera(this.settings.model);
      this._protal = new EnterPointSet(
        this.settings.model.modelIndexEnterType,
        this.settings.pointPortalList);
      if( this._protal.enterType === EnterType.God && this.settings.model.modelShowType === 1) {
        this._protal.enterType = EnterType.Pano
      }
      this.renderElement = document.getElementById("model-demo");
      this._renderer = new Renderer(this.renderElement);
      this.renderElement = this._renderer.renderer.domElement;
      this._material.initRenderer(this._renderer.renderer);

      this._renderer.load = false;
      this._audioMgr = new AudioManager(
        null,
        null,
        this.settings.model.isSwitchBackgroundMusic,
        this.settings.model.isPlayOnHotpoint
      );
      /**********/
      this._control = new CameraController(
        this._camera,
        this._cpointset,
        this._material,
        this._scene,
        this._renderer,
        this._singleView,
        this.settings.model.modelShowType === 1
      );
      window.addEventListener("resize", this.onWindowResize.bind(this), false);
      this._view = new ViewSet();
      this._view.initSceneView(
        this.settings.model,
        this.settings.viewList
      );

      if (this.isEdit)
        this._epointset.fillTruePoints(
          this._protal.portals,
          this._view.viewList
        );

      this._hud = new HUD();
      this._emitter = new EventEmitter();
      this._emitter.on("loadingTo", this.loadingTo.bind(this));

      this._tagSet = new BuildingTagSet();
      initBuildingTags(this._tagSet, this.settings.model.isShowMark, this.settings.markerList);
      this._scene.scene.add(this._tagSet.root);

      // todo　初始化
      this._exObjSet = new ExtraObjectSet();
      this._hpSet = new HotpointSet(this._exObjSet);

      initHotpoints(
        this._hpSet,
        this._exObjSet,
        this.settings.model.isShowIn3d,
        this.settings.model.isFiveMeter,
        this.settings.hotpointList,
        this._audioMgr,
        this._view
      );
      this._scene.scene.add(this._hpSet.root);
      this._scene.scene.add(this._exObjSet.group);

      this._hpPlayer = new HotpointPlayer(
        this.settings.animationList.map(item => item.hotpointId),
        this._hpSet,
        this._control,
        this._cpointset
      );
    },

    /**
     * 调整窗口大小，保持相机宽高比
     */
    onWindowResize() {
      const d = document.getElementById("model-demo");
      const width = d.clientWidth;
      const height = d.clientHeight;
      this._camera.orthRange = 25000 / height;
      this._camera.orthCamera.left = -width * this._camera.orthRange;
      this._camera.orthCamera.right = width * this._camera.orthRange;
      this._camera.orthCamera.top = height * this._camera.orthRange;
      this._camera.orthCamera.bottom = -height * this._camera.orthRange;

      this._camera.persCamera.aspect = width / height;

      this._camera.camera.updateProjectionMatrix();
      this._renderer.renderer.setSize(width, height);
    },

    async load() {
      await this._model.initModel(
        this._emitter,
        this._scene.scene,
        this._material.material,
        this._godMaterial
      );

      //***********GUI*********//
      document.addEventListener('keydown',this.initGUI)
      //***********GUI*********//
      this._control.setSceneCenter(this._model.center)
      this.initEnterState(
        this._camera,
        this._protal,
        this._model,
        this._cpointset,
        this._material,
        this._control,
      );

      this._singleView.initScene2();

      this._control.initCameraController();

      let ua = Utils.getPlatform();
      if (ua.platform !== "pc") {
        this._touch = new MobileTouch(
          this.renderElement,
          this._cpointset,
          this._model,
          this._hpSet,
          this._renderer
        );
        this._touch.init();

        this._control.addInput(this._touch);
      } else {
        const cursorIconUrl = require('@/assets/img/pictures/location_512x512.png');
        this._cursor = new Cursor(
          cursorIconUrl,
          this.renderElement,
          this._scene.scene,
          this._renderer,
          this._cpointset,
          this._model,
          this._hpSet,
          this.isEdit,
          this._epointset
        );
        this._cursor.init(cursorIconUrl);

        this._keyboard = new Keyboard(this._renderer, this._cpointset);
        this._keyboard.init();

        this._touch = new MobileTouch(
          this.renderElement,
          this._cpointset,
          this._model,
          this._hpSet,
          this._renderer
        );
        this._touch.init();

        this._control.addInput(this._touch);
        this._control.addInput(this._cursor);
        this._control.addInput(this._keyboard);
      }

      this._view.init(this._renderer, this._control);

      this._hud.init(this._control.inputs);
      this._renderer.load = true;

      this._emitter.emit("loadingTo", 100);
      this.onWindowResize();

      this._renderer.active = true;
      this.addListener();

      this._control.animate();

      this.$emit("onSceneReady");
    },

    /**
     * 添加监听器
     */
    addListener() {
      this._control.events.on(Events.To2D, () => console.log("to 2d"));
      this._control.events.on(Events.To3D, () => console.log("to 3d"));
      this._control.events.on(Events.BeforeWalkIn3D, ()=> {
        // console.log("3d walking");
        this._godMaterial.sendMaterial(this._model.renderObjs);

      })
      this._control.events.on(Events.AfterWalkIn3D, ()=>{
        // console.log("3d walking end");
        this._material.sendMaterial(this._model.renderObjs);
      })

      this._control.events.on(Events.BeforeToGod, () => {
        // console.log("before to god");
        this._model.removeCube();
        this._godMaterial.sendMaterial(this._model.renderObjs);
        this._tagSet.visible = true;
        this._hpSet.visible = false;
        if (this.isEdit) this._epointset.hideEditPoint();
      });

      this._control.events.on(Events.ToPano, (idx, pos) => {
        // console.log("to pano ", idx);
        parent.postMessage({type:Events.ToPano, msg: {id: idx}}, '*')
        this._material.newTextureDone();
        this._model.addCube();
        this._material.sendMaterial(this._model.renderObjs);
        this._tagSet.visible = false;
        this._hpSet.visible = true;
        if(!Utils.isSingleView(idx)){
          this._hpSet.calAndSetHotPointVisible(pos);
        }
        if (this.isEdit) this._epointset.showEditPoint();
      });

      this.$on(Events.HotpointClose, () => {
        this._audioMgr.stopHp();
      });

      this._control.events.on(Events.AfterWalkTo, (idx) => {
        // console.log("after walk to ", idx);
        parent.postMessage({type:Events.AfterWalkTo, msg: {id: idx}}, '*')
        if(!Utils.isSingleView(idx)){
          this._hpSet.calAndSetHotPointVisible(
            this._cpointset.getCameraPoint(idx).position
          );
        };
      });

      this._control.events.on(Events.BeforeWalkTo, (idx) => {
        // console.log(idx)
        parent.postMessage({type:Events.BeforeWalkTo, msg: {id: idx}}, '*')
      });

      this._control.events.on(Events.Update, () => {
        this._hpSet.update();
        if(this._camera.cameraMode) {
          this._material.autoLoadCubeFace(this._camera.target, this._camera.camera.position, this._cpointset);
        }
      });

      this._camera.events.on(Events.CameraFovChange, (fov) => {
        this._tagSet.tagResize(fov / 65);
        this._hpSet.resize(fov / 65);
        this._material.updateMaterialFov(fov / 65.0)
      });

      this._camera.events.on(Events.MainCameraChange, (cam) => {
        if (cam instanceof THREE.OrthographicCamera) {
          this._tagSet.tagResize(44000);
          this._hpSet.resize(44000);
        }
      });
    },

    /**
     * 进入VR方法
     */
    enterVR() {
      if (!this._vr) {
        this._vr = new VRControl(this.renderElement);
        this._vr.init(
          this._cpointset,
          this._scene.scene,
          this._renderer,
          this._control
        );
        this._control.events.on(Events.Update, this._vr.updateBind);
      }
      this._vr.onVR();
    },

    /**
     * 离开VR模式
     */
    exitVR() {
      if (this._vr) {
        this._vr.offVR();
        this._control.events.removeListener(Events.Update, this._vr.updateBind);
        this._vr.depose();
      }
      this._vr = null;
    },

    /**
     * 初始化进入状态
     * @param {Camera} cam 摄像机
     * @param {EnterPointSet} portal 进入点
     * @param {Model} model 模型
     * @param {CPointSet} cps 点位集合
     * @param {Material} mt 材质
     * @param {CameraController} control 控制器
     */
    initEnterState(cam, portal, model, cps, mt, control) {
      const portalId = this.$route.query.p;
      const currPortal = portal.portals[portalId];
      const angle = currPortal ? currPortal.angle : new THREE.Vector2(-90, 0);
      const target = currPortal ? currPortal.idx : 0;
      cam.lon = angle.x;
      cam.lat = angle.y;
      cam.cameraCurrentIndex = target;
      cam.cameraDestinationIndex = target;
      control.savePoint = target;
      mt.init(target, cps.getCameraPoint(target).correctMat);

      // 初始化问题
      if (portal.enterType !== EnterType.Pano) {
        model.removeCube();
        cam.cameraMode = false;
        if (this.isEdit) this._epointset.hideEditPoint();
        this._godMaterial.sendMaterial(model.renderObjs);

        this._hpSet.visible = false;
        this._tagSet.visible = true;
      } else {
        model.addCube();
        cam.cameraMode = true;
        if (this.isEdit) this._epointset.showEditPoint();
        this._material.sendMaterial(model.renderObjs);

        this._hpSet.visible = true;
        this._hpSet.calAndSetHotPointVisible(
          cps.getCameraPoint(target).position
        );

        this._tagSet.visible = false;
      }
      cam.initCamera(cps.getCameraPoint(target).position, model.center);
      // 预渲染一次上帝视角的模型
      if (portal.enterType === EnterType.Pano) {
        this._godMaterial.sendMaterial(model.renderObjs);
        this._renderer.renderer.render(this._scene.scene, this._camera.camera)
        this._material.sendMaterial(model.renderObjs);
      }
    },

    /**
     * 进度条
     * @param {number} number 进度条数字
     */
    loadingTo(number) {
      this.$emit("loadingTo", number);
    },
    async enterScene() {
      if (this._protal.enterType === EnterType.GodToPano) {
        await this._control.toPano();
      }
    },

    /**
     * 资源释放方法
     * @param {} parent 父节点
     * @param {} child 子节点
     */
    dispose(parent, child) {
      if (child.children.length) {
        let arr = child.children.filter((x) => x);
        arr.forEach((a) => {
          this.dispose(child, a);
        });
      }
      if (child instanceof THREE.Mesh || child instanceof THREE.Line) {
        if (child.material.map) child.material.map.dispose();
        child.material.dispose();
        child.geometry.dispose();
      } else if (child.material) {
        child.material.dispose();
      }
      child.remove();
      parent.remove(child);
    },
    /**
     * @param {{}} msg 热点信息，见后端表，数组类型要转为真正的数组类型
     * @param {{
     * isShowTitle:boolean,
     * fontSize:number,
     * switchAttenuation:string,
     * fontColor:string,
     * backgroundColor:boolean
     * }} style 热点样式
     */
    addHotpoint(msg, style) {
      addHotpoint(this._hpSet, this._exObjSet, this._audioMgr, this._view,
        msg, style, msg.hotpointPosition, msg.normal, msg.cornerPosition, true);
    },

    resetCurrection(x, y, z) {
      if(!this._camera.cameraMode) return;
      let cp = this._cpointset.getCameraPoint(this._camera.cameraCurrentIndex);
      cp.pointCorrect = new Euler(MathUtils.degToRad(x), MathUtils.degToRad(y), MathUtils.degToRad(z));
      cp.resetCorrectMat();
      this._material.uniforms.correct.value = cp.correctMat;
    },

    /**
     * 资源释放方法
     */
    delete() {
      this._control.runtimeFlag = false;

      let scene = this._scene.scene;
      let renderer = this._renderer.renderer;
      let arr = scene.children.filter((x) => x);
      for (let i = 0; i < arr.length; ++i) {
        this.dispose(scene, arr[i]);
      }
      scene.remove();
      renderer.dispose();
      renderer.forceContextLoss();
      renderer.content = null;
      renderer.domElement = null;
      window.cancelAnimationFrame(this._control.id);
      scene = null;
      renderer = null;

      for (const item of this._control.inputs) {
        item.depose();
      }

      // 删除单例
      delete this._scene;
      delete this._camera;
      delete this._material;
      delete this._model;
      delete this._cpointset;
      delete this._renderer;
      delete this._keyboard;
      delete this._cursor;
      delete this._touch;
      delete this._control;
      delete this._view;
      delete this._tagSet;
    },

    /**
     * 初始化GUI调试面板方法
     */
    initGUI(event){
      if(event.keyCode===221){
        this._guitool = new GUITool()
        document.removeEventListener('keydown',this.initGUI)
      }
    }
  },
  computed: {},
  beforeDestroy() {
    // this.delete();
  },
};
</script>

// 样式

<style scoped>
#modelcomp {
  width: 100%;
  height: 100%;
}

#model-demo {
  width: 100%;
  height: 100%;
  background-color: black;
  touch-action: none;
}

#waiting-texture {
  position: absolute;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  display: none;
  align-items: center;
  justify-content: center;
}

.waiting-texture {
  font-size: 30px;
  transform: rotate(360deg);
  transition: 3.6s;
}
</style>
